import clsx from 'clsx';

import { useFormattedPrice } from '~/shared/hooks/useFormattedPrice';

import styles from './productDetailsPrice.module.css';

export type ProductDetailsPriceProps = {
	className?: string;
	price: number;
	discountedPrice?: number;
};

export const ProductDetailsPrice = ({ className, price, discountedPrice }: ProductDetailsPriceProps) => {
	const formattedPrice = useFormattedPrice(price, true);
	const formattedDiscountPrice = useFormattedPrice(discountedPrice, true);

	const isDiscount = Boolean(formattedDiscountPrice);

	const actualPrice = isDiscount ? formattedDiscountPrice : formattedPrice;
	const priceClassName = isDiscount ? styles.discount : styles.amount;

	return (
		<div className={clsx(styles.root, className)}>
			<div className={priceClassName}>{actualPrice}</div>
			{formattedDiscountPrice && <div className={styles.old}>{formattedPrice}</div>}
		</div>
	);
};
